<template>
    <v-card class="mb-5 pa-2">
        <v-form ref="form" @submit.prevent="save">
            <template>
                <card-header :title="'Editar Cliente'"></card-header>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            v-model="model.trade_name"
                            disabled
                            label="Nome"
                        ></v-text-field>
                    </v-col>
                    <template v-if="canEdit()">
                        <v-col cols="12" xs="12" sm="12" md="6">
                            <v-currency-field
                                label="Desconto cliente"
                                v-bind="$t('money-config')"
                                v-model="model.discount"
                                :error-messages="DiscountErrors"
                                @input="$v.model.discount.$touch()"
                                @blur="$v.model.discount.$touch()"
                                :disabled="!model.reseller.billable"
                                autofocus
                            ></v-currency-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6">
                            <label class="caption">
                                {{ $t('forms.customer.labels.status') }}
                            </label>
                            <v-radio-group
                                row
                                dense
                                v-model="situation"
                                class="mt-1"
                            >
                                <v-radio
                                    :label="
                                        $t('forms.customer.statuses.active')
                                    "
                                    color="green"
                                    value="active"
                                ></v-radio>
                                <v-radio
                                    :label="
                                        $t('forms.customer.statuses.blocked')
                                    "
                                    color="red"
                                    value="blocked"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6">
                            <v-switch
                                v-model="model.ignore"
                                :hint="$t('forms.customer.hints.ignore')"
                            >
                                <template v-slot:label>
                                    {{ $t('forms.customer.labels.ignore') }}

                                    <v-tooltip bottom>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                class="ml-2"
                                                v-bind="attrs"
                                                v-on="on"
                                                >mdi-information</v-icon
                                            >
                                        </template>
                                        <span>{{
                                            $t('forms.customer.hints.ignore')
                                        }}</span>
                                    </v-tooltip>
                                </template>
                            </v-switch>
                        </v-col>
                    </template>
                </v-row>
                <form-actions :loadingSave="loading" />
            </template>
        </v-form>
    </v-card>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import BaseModel from '@/models/BaseModel'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    props: {
        customer: {
            type: Object,
            required: true,
            validator: customer => {
                return customer instanceof BaseModel
            },
        },
    },

    components: {
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    data: () => {
        return {
            loading: false,
            situation: null,
        }
    },

    mixins: [validationMixin],

    validations: {
        model: {
            discount: { required },
        },
    },

    methods: {
        async save() {
            this.loading = true

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('form.validation-error'),
                )

                this.loading = false
                return
            }

            let clone = this.model.clone()
            clone.blocked = this.situation === 'blocked'
            clone.canceled = this.situation === 'canceled'
            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$emit('saved')

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('modules.form.feedback.success', { name: clone.name }),
            )
        },

        clear() {
            this.$refs.form.reset()
        },

        canEdit() {
            return this.can('update customers')
        },
    },

    computed: {
        model() {
            return this.customer
        },

        isBillable() {
            return this.customer.reseller.billable
        },

        DiscountErrors() {
            const errors = []
            if (!this.$v.model.discount.$dirty) return errors

            !this.$v.model.discount.required &&
                errors.push(
                    this.$t('modules.form.validations.cplug-price.required'),
                )

            return errors
        },
    },

    created() {
        this.situation = 'active'

        if (this.customer.blocked_at.isValid()) {
            this.situation = 'blocked'
        } else if (this.customer.canceled_at.isValid()) {
            this.situation = 'canceled'
        }
    },
}
</script>
